import { UserButton } from "@clerk/clerk-react";
import { Building2, CreditCard, LayoutDashboard, Users } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useMe } from "@/hooks/useMe";

const navItems = [
	{ to: "/", icon: LayoutDashboard, label: "Overview" },
	{ to: "/clients", icon: Building2, label: "Clients" },
	{ to: "/billing", icon: CreditCard, label: "Billing" },
	{ to: "/members", icon: Users, label: "Members" },
] as const;

export const Sidebar = () => {
	const { data: me } = useMe();
	// Hide the Members entry for read-only staff; the server enforces the
	// owner/admin gate regardless.
	const items = navItems.filter(
		(item) => item.to !== "/members" || me?.member.role !== "member",
	);

	return (
		<aside className="w-56 bg-sidebar border-r border-clyr-gray-800 flex flex-col">
			<div className="p-4">
				<div className="text-clyr-blue-400 font-bold text-lg mb-1">
					Clyr Partner
				</div>
				<div className="text-clyr-gray-500 text-xs mb-8 truncate">
					{me?.partner.name ?? ""}
				</div>
				<nav className="space-y-1">
					{items.map((item) => (
						<NavLink
							key={item.to}
							to={item.to}
							end={item.to === "/"}
							className={({ isActive }) =>
								`flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
									isActive
										? "bg-sidebar-accent text-sidebar-accent-foreground"
										: "text-sidebar-muted hover:text-sidebar-foreground hover:bg-sidebar-accent/50"
								}`
							}
						>
							<item.icon className="h-4 w-4" />
							<span className="flex-1">{item.label}</span>
						</NavLink>
					))}
				</nav>
			</div>
			<div className="mt-auto p-4 border-t border-clyr-gray-800">
				<UserButton afterSignOutUrl="/sign-in" />
			</div>
		</aside>
	);
};
